<script>
import TopNavbar from "@/layout/dashboard/TopNavbar.vue";
import MailingListForm from "@/pages/MailingList/_form.vue";
import {axiosApiInstance} from "@/axiosInterceptor";

export default {
  name: 'mailing-new',
  components: {
    MailingListForm,
    TopNavbar
  },
  data() {
    return {
      user: null,
      mailingList: {
        label: '',
        description: '',
      }
    }
  },
  mounted() {
    this.getCurrentUser()
  },
  methods: {
    getCurrentUser() {
      axiosApiInstance.get(process.env.VUE_APP_API_URL + '/api/me').then(response => {
        this.user = response.data
        this.mailingList.company = this.user.company['@id']
      }).catch(e => {
        this.flash = {message: e.message, type: 'danger'}
      })
    },
  }
}

</script>

<template>
  <div class="wrapper">
    <side-bar>

    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <div class="content">
        <h1>Nouvelle liste d'emails</h1>
        <MailingListForm :mailinglist="mailingList" v-if="mailingList" :scope="'new'"/>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>